import { css } from "@emotion/css";
import { Fonts } from "@snapchat/snap-design-system";

export const lensesListScroll = css`
    overflow: auto;
    max-height: 60vh;
`;

export const modalTitle = css`
    ${Fonts.Heading.H400}
    margin: 0 0 16px 10px;
`;

export const searchItemsContainer = css`
    margin: 8px 0 0;
    border: none;
    box-shadow: none;

    .sds-card-header {
        padding-left: 8px;
    }

    .sds-vtable-cell {
        /* unfortunately, SDS does not provide another way to tweak it: */
        padding: 0 8px !important;
    }

    .sds-vtable-header-row {
        border: none;
    }
`;
